import { BreadcrumbItem } from '@mitsubishi/shared/ui';

export class SetBreadcrumbs {
  static readonly type = '[Breadcrumbs] Set';
  constructor(public breadcrumbs: BreadcrumbItem[]) {}
}
